import React from "react";
import {
  Routes, // instead of "Switch"
  Route,
  useLocation,
} from "react-router-dom";
import Home from "./Home";
import ConnectedLaptop from "./ConnectedLaptop";
import CustomerOffice from "./CustomerOffice";
import OntheMove from "./OntheMove";
import WorkFromHome from "./WorkfromHome";
import Construction from "./ConstructionsiteProductivity";
import RetailOperation from "./RetailOperation";
import Healthcare from "./Healthcare";
import CyberRecovery from "./CyberRecovery";
import Edge from "./Edge";
import EdgeLogistics from "./Edge-Logistics";
import EdgeManufacturing from "./Edge-Manufacturing";
import PrivateMobility from "./Private-Mobility";
import PrivateMobilityCampus from "./Private-Mobility-Campus";
import PrivateMobilityAirport from "./Private-Mobility-Airport";
import IntegratedSolution from "./Integrated-Solution";
import Experience from "./Experience";
import { AnimatePresence } from "framer-motion";


function AnimatedRoutes() {
  const location = useLocation();
  return (
      <main id="main" class="animatedRoutes">
         <AnimatePresence mode="wait" initial={false}>
          <Routes location={location} key={location.pathname}>
            <Route path="/connected-laptop" element={<ConnectedLaptop />} />
            <Route path="/connected-laptop/customer-office" element={<CustomerOffice />} />
            <Route path="/connected-laptop/on-the-move" element={<OntheMove />} />
            <Route path="/connected-laptop/work-from-home" element={<WorkFromHome />} />
            <Route path="/connected-laptop/construction-site-productivity" element={<Construction />} />
            <Route path="/cyber-recovery" element={<CyberRecovery />} />
            <Route path="/cyber-recovery/retail-operation" element={<RetailOperation />} />
            <Route path="/cyber-recovery/healthcare" element={<Healthcare />} />
            <Route path="/edge-compute" element={<Edge />} />
            <Route path="/edge-compute/manufacturing" element={<EdgeManufacturing />} />
            <Route path="/edge-compute/logistics" element={<EdgeLogistics />} />
            <Route path="/private-wireless" element={<PrivateMobility />} />
            <Route path="/private-wireless/airports" element={<PrivateMobilityAirport />} />
            <Route
              path="/private-wireless/campus"
              element={<PrivateMobilityCampus />}
            />
            <Route path="/integrated-solution" element={<IntegratedSolution />} />
            <Route path="/home" element={<Home />} />
            <Route path="/" element={<Experience />} />
          </Routes>
        </AnimatePresence>
      </main>

  );
}

export default AnimatedRoutes;
